import { UpdateAdminOfficeIPPayload } from "./../@types/Ip";
import { AxiosResponse } from "axios";
import {
  GetAdminOfficeIPPayload,
  GetAdminOfficeIPResponse,
} from "../@types/Ip";
import axiosInstance from "../configs/axiosConfig";
import { IP_ENDPOINT } from "../configs/endpoints";
import { BaseResponse } from "../@types/Response";
import { EMPTY_STRING } from "lib/Const";

export const ipServices = {
  getAdminOfficeIP: async (payload: GetAdminOfficeIPPayload) => {
    const data = new FormData();
    const userId =
      JSON.parse(localStorage.getItem("redux") ?? "{}")?.userInfo?.aduserid ??
      EMPTY_STRING;
    data.append("useridauth", userId);
    data.append("adcompanyid", payload.adcompanyid);
    const response: AxiosResponse<GetAdminOfficeIPResponse[]> =
      await axiosInstance.post(IP_ENDPOINT.GET_IP, data);
    return response;
  },
  updateAdminOfficeIP: async (payload: UpdateAdminOfficeIPPayload) => {
    const userId =
      JSON.parse(localStorage.getItem("redux") ?? "{}")?.userInfo?.aduserid ??
      EMPTY_STRING;
    const response: AxiosResponse<BaseResponse[]> = await axiosInstance.post(
      IP_ENDPOINT.UPDATE_IP,
      { ...payload, useridauth: userId }
    );
    return response;
  },
};
